var map = {
	"./components/ActionMenu.vue": [
		24318,
		[
			58255,
			24318
		]
	],
	"./components/AdviserFeesChargesMediaTable.vue": [
		71285,
		[
			71285
		]
	],
	"./components/App.vue": [
		84024,
		[]
	],
	"./components/AppAccountSwitcher.vue": [
		2801,
		[
			58255,
			2801
		]
	],
	"./components/AppAccountSwitcherList.vue": [
		65072,
		[
			58255,
			65072
		]
	],
	"./components/AppAlert.vue": [
		65225,
		[
			65225
		]
	],
	"./components/AppAlertButton.vue": [
		60313,
		[
			60313
		]
	],
	"./components/AppAutocomplete.vue": [
		57812,
		[
			58255,
			57812
		]
	],
	"./components/AppBackButton.vue": [
		98724,
		[
			98724
		]
	],
	"./components/AppBar.vue": [
		45642,
		[
			58255,
			45642
		]
	],
	"./components/AppBreadcrumbs.vue": [
		35737,
		[
			35737
		]
	],
	"./components/AppButton.vue": [
		34779,
		[
			58255,
			34779
		]
	],
	"./components/AppButtonCancel.vue": [
		19415,
		[
			19415
		]
	],
	"./components/AppButtonClose.vue": [
		63953,
		[
			63953
		]
	],
	"./components/AppCard.vue": [
		9280,
		[
			9280
		]
	],
	"./components/AppChart.vue": [
		39274,
		[
			66272,
			39274
		]
	],
	"./components/AppChip.vue": [
		3265,
		[
			3265
		]
	],
	"./components/AppCodeEditor.vue": [
		50611,
		[
			58255,
			98174,
			33311,
			5845
		]
	],
	"./components/AppCompatibilityWarning.vue": [
		83386,
		[
			83386
		]
	],
	"./components/AppContrastCheck.vue": [
		33823,
		[
			33823
		]
	],
	"./components/AppCopyButton.vue": [
		57664,
		[
			57664
		]
	],
	"./components/AppDialog.vue": [
		18620,
		[]
	],
	"./components/AppDialogQueue.vue": [
		46553,
		[
			46553
		]
	],
	"./components/AppDivider.vue": [
		50026,
		[
			50026
		]
	],
	"./components/AppDurationDisplayToggle.vue": [
		67493,
		[
			67493
		]
	],
	"./components/AppEditableRow.vue": [
		32574,
		[
			32574
		]
	],
	"./components/AppExpansionPanel.vue": [
		99006,
		[
			99006
		]
	],
	"./components/AppExportTable.vue": [
		45246,
		[
			70504,
			54294,
			45246
		]
	],
	"./components/AppField.vue": [
		86278,
		[
			86278
		]
	],
	"./components/AppFieldset.vue": [
		72201,
		[
			72201
		]
	],
	"./components/AppFileDrop.vue": [
		60513,
		[
			58255,
			60513
		]
	],
	"./components/AppFilePreview.vue": [
		12886,
		[
			58255,
			12886
		]
	],
	"./components/AppFilterPanel.vue": [
		93096,
		[
			58255,
			93096
		]
	],
	"./components/AppFilterPanelItem.vue": [
		76310,
		[
			58255,
			76310
		]
	],
	"./components/AppFilterPanels.vue": [
		91635,
		[
			91635
		]
	],
	"./components/AppFitText.vue": [
		39999,
		[
			70504,
			39999
		]
	],
	"./components/AppFormCard.vue": [
		45310,
		[
			58255,
			45310
		]
	],
	"./components/AppGroup.vue": [
		31248,
		[
			31248
		]
	],
	"./components/AppImage.vue": [
		75080,
		[
			58255,
			75080
		]
	],
	"./components/AppInvestorAdditionalNeeds.vue": [
		4768,
		[
			4768
		]
	],
	"./components/AppInvestorPortfolioWarning.vue": [
		47121,
		[
			47121
		]
	],
	"./components/AppItemGroup.vue": [
		50551,
		[
			58255,
			50551
		]
	],
	"./components/AppLacuna.vue": [
		8157,
		[
			8157
		]
	],
	"./components/AppLink.vue": [
		26495,
		[
			26495
		]
	],
	"./components/AppList.vue": [
		50317,
		[
			50317
		]
	],
	"./components/AppListItem.vue": [
		17417,
		[
			17417
		]
	],
	"./components/AppLoading.vue": [
		92606,
		[
			58255,
			92606
		]
	],
	"./components/AppLogo.vue": [
		78852,
		[
			58255,
			78852
		]
	],
	"./components/AppLogoutButton.vue": [
		5214,
		[
			82833
		]
	],
	"./components/AppMediaFilePreview.vue": [
		99841,
		[
			58255,
			99841
		]
	],
	"./components/AppMediaItemPreview.vue": [
		62630,
		[
			62630
		]
	],
	"./components/AppMediaLibrary.vue": [
		10148,
		[
			10148
		]
	],
	"./components/AppMediaUploadPreview.vue": [
		49193,
		[
			58255,
			49193
		]
	],
	"./components/AppMenu.vue": [
		23610,
		[
			23610
		]
	],
	"./components/AppMenuButton.vue": [
		48658,
		[
			48658
		]
	],
	"./components/AppMenuPanel.vue": [
		76943,
		[
			58255,
			76943
		]
	],
	"./components/AppMoneyProgress.vue": [
		25030,
		[
			25030
		]
	],
	"./components/AppNavMenu.vue": [
		80955,
		[
			80955
		]
	],
	"./components/AppNavMenuItem.vue": [
		65206,
		[
			65206
		]
	],
	"./components/AppNotification.vue": [
		78014,
		[
			78014
		]
	],
	"./components/AppNotificationPreferenceTemplates.vue": [
		11650,
		[
			11650
		]
	],
	"./components/AppNotifications.vue": [
		96039,
		[
			58255,
			96039
		]
	],
	"./components/AppNotificationsDrawer.vue": [
		48990,
		[
			48990
		]
	],
	"./components/AppOptionCard.vue": [
		78568,
		[
			78568
		]
	],
	"./components/AppOverlay.vue": [
		6678,
		[
			6678
		]
	],
	"./components/AppPageHeader.vue": [
		76115,
		[
			76115
		]
	],
	"./components/AppParamSelector.vue": [
		84765,
		[
			84765
		]
	],
	"./components/AppPdf.vue": [
		58661,
		[
			81042
		]
	],
	"./components/AppPermissions.vue": [
		81813,
		[
			58255,
			81813
		]
	],
	"./components/AppPermissionsDrawer.vue": [
		18648,
		[
			18648
		]
	],
	"./components/AppPlatformModal.vue": [
		9628,
		[
			9628
		]
	],
	"./components/AppProgress.vue": [
		69618,
		[
			47237
		]
	],
	"./components/AppProgressQueue.vue": [
		79277,
		[
			79277
		]
	],
	"./components/AppQuerySelector.vue": [
		32291,
		[
			32291
		]
	],
	"./components/AppQuestion.vue": [
		6758,
		[
			6758
		]
	],
	"./components/AppQuestionAnswer.vue": [
		15564,
		[
			15564
		]
	],
	"./components/AppQuestionnaire.vue": [
		2262,
		[
			58255,
			2262
		]
	],
	"./components/AppRiskWarning.vue": [
		34681,
		[
			34681
		]
	],
	"./components/AppRow.vue": [
		78504,
		[
			58255,
			78504
		]
	],
	"./components/AppScrollbar.vue": [
		77563,
		[
			77563
		]
	],
	"./components/AppSearch.vue": [
		29466,
		[
			58255,
			29466
		]
	],
	"./components/AppSection.vue": [
		70827,
		[
			58255,
			70827
		]
	],
	"./components/AppSessionExpired.vue": [
		92573,
		[
			92573
		]
	],
	"./components/AppSnack.vue": [
		91761,
		[
			91761
		]
	],
	"./components/AppSnackQueue.vue": [
		68815,
		[
			58255,
			68815
		]
	],
	"./components/AppSwitch.vue": [
		67834,
		[
			67834
		]
	],
	"./components/AppTabs.vue": [
		27293,
		[
			58255,
			27293
		]
	],
	"./components/AppTermsModal.vue": [
		75668,
		[
			75668
		]
	],
	"./components/AppText.vue": [
		94965,
		[
			94965
		]
	],
	"./components/AppThemeColour.vue": [
		54166,
		[
			58255,
			54166
		]
	],
	"./components/AppThemeColours.vue": [
		12178,
		[
			58255,
			12178
		]
	],
	"./components/AppTimeline.vue": [
		15442,
		[
			58255,
			15442
		]
	],
	"./components/AppTimelineItem.vue": [
		81561,
		[
			58255,
			81561
		]
	],
	"./components/AppTodoIndicator.vue": [
		24984,
		[
			2603
		]
	],
	"./components/AppToggleClosedOffers.vue": [
		68956,
		[
			68956
		]
	],
	"./components/AppToggleClosedPositions.vue": [
		70290,
		[
			70290
		]
	],
	"./components/AppToggleConsolidatedView.vue": [
		58293,
		[
			58293
		]
	],
	"./components/AppToggleNavTotals.vue": [
		72703,
		[
			72703
		]
	],
	"./components/AppTogglePanelOffers.vue": [
		84333,
		[
			84333
		]
	],
	"./components/AppToggleQuarantinedMedia.vue": [
		16456,
		[
			16456
		]
	],
	"./components/AppTooltip.vue": [
		11210,
		[
			58255,
			11210
		]
	],
	"./components/AppUserFeedback.vue": [
		42394,
		[
			42394
		]
	],
	"./components/AppVideo.vue": [
		94138,
		[
			58255,
			70504,
			36291
		]
	],
	"./components/AppViewVersionSwitcher.vue": [
		43408,
		[
			43408
		]
	],
	"./components/AppWrapper.vue": [
		73222,
		[
			73222
		]
	],
	"./components/AppWysiwyg.vue": [
		68430,
		[
			68430
		]
	],
	"./components/AppWysiwygOutline.vue": [
		30813,
		[
			30813
		]
	],
	"./components/AppWysiwygToolbar.vue": [
		59998,
		[
			58255,
			59998
		]
	],
	"./components/AppWysiwygToolbarAction.vue": [
		57020,
		[
			57020
		]
	],
	"./components/AppWysiwygToolbarField.vue": [
		78019,
		[
			78019
		]
	],
	"./components/AppWysiwygToolbarFieldMenu.vue": [
		47092,
		[
			58255,
			47092
		]
	],
	"./components/AppWysiwygToolbarMark.vue": [
		51581,
		[
			51581
		]
	],
	"./components/AppWysiwygToolbarTypeMenu.vue": [
		91431,
		[
			58255,
			91431
		]
	],
	"./components/BrandingImageUpload.vue": [
		15153,
		[
			58255,
			15153
		]
	],
	"./components/BulkUpdate.vue": [
		23458,
		[
			23458
		]
	],
	"./components/CreateEventModal.vue": [
		67262,
		[
			67262
		]
	],
	"./components/CreateValuationModal.vue": [
		39321,
		[
			39321
		]
	],
	"./components/CustodianBankDetails.vue": [
		73283,
		[
			73283
		]
	],
	"./components/DynamicForm.vue": [
		979,
		[
			58255,
			979
		]
	],
	"./components/EmailViewer.vue": [
		13853,
		[
			13853
		]
	],
	"./components/InvestorAdviserAccountSelector.vue": [
		38649,
		[
			38649
		]
	],
	"./components/InvestorAdviserSelector.vue": [
		42162,
		[
			42162
		]
	],
	"./components/InvestorProviderSelector.vue": [
		85853,
		[
			85853
		]
	],
	"./components/NotificationPreference.vue": [
		15495,
		[
			15495
		]
	],
	"./components/NotificationPreferencesList.vue": [
		29804,
		[
			29804
		]
	],
	"./components/OverlayTierRestriction.vue": [
		83980,
		[
			83980
		]
	],
	"./components/ReportWidget.vue": [
		51925,
		[
			51925
		]
	],
	"./components/SwitchCountry.vue": [
		97799,
		[
			58255,
			97799
		]
	],
	"./components/TextAnimationLoader.vue": [
		74404,
		[
			74404
		]
	],
	"./components/UserEmailInbox.vue": [
		98366,
		[
			98366
		]
	],
	"./components/UserEmailInboxButton.vue": [
		7503,
		[
			7503
		]
	],
	"./components/UserNotificationPreferencesButton.vue": [
		36483,
		[
			36483
		]
	],
	"./components/UserSetupMfaButton.vue": [
		52633,
		[
			52633
		]
	],
	"./components/charts/AccountBalance.vue": [
		25795,
		[
			25795
		]
	],
	"./components/display/Boolean.vue": [
		19015,
		[
			19015
		]
	],
	"./components/display/Content.vue": [
		67482,
		[
			67482
		]
	],
	"./components/display/Date.vue": [
		95040,
		[
			95040
		]
	],
	"./components/display/Datetime.vue": [
		39949,
		[
			39949
		]
	],
	"./components/display/Display.vue": [
		30570,
		[
			30570
		]
	],
	"./components/display/EmailAddress.vue": [
		79732,
		[
			79732
		]
	],
	"./components/display/Enum.vue": [
		90365,
		[
			90365
		]
	],
	"./components/display/Fee.vue": [
		85068,
		[
			85068
		]
	],
	"./components/display/Link.vue": [
		18176,
		[
			18176
		]
	],
	"./components/display/Money.vue": [
		82076,
		[
			82076
		]
	],
	"./components/display/Number.vue": [
		31583,
		[
			31583
		]
	],
	"./components/display/Percentage.vue": [
		67058,
		[
			67058
		]
	],
	"./components/display/PhoneNumber.vue": [
		59355,
		[
			59355
		]
	],
	"./components/display/String.vue": [
		17758,
		[
			17758
		]
	],
	"./components/dynamic-form-builder/Index.vue": [
		31143,
		[
			58255,
			31143
		]
	],
	"./components/edit/Boolean.vue": [
		89104,
		[
			58255,
			89104
		]
	],
	"./components/edit/Content.vue": [
		70391,
		[
			70391
		]
	],
	"./components/edit/Date.vue": [
		13190,
		[
			58255,
			13190
		]
	],
	"./components/edit/Datetime.vue": [
		68187,
		[
			58255,
			68187
		]
	],
	"./components/edit/Edit.vue": [
		14406,
		[
			14406
		]
	],
	"./components/edit/Enum.vue": [
		6624,
		[
			6624
		]
	],
	"./components/edit/File.vue": [
		44106,
		[
			58255,
			44106
		]
	],
	"./components/edit/Money.vue": [
		15147,
		[
			58255,
			15147
		]
	],
	"./components/edit/Number.vue": [
		96880,
		[
			58255,
			96880
		]
	],
	"./components/edit/Paragraph.vue": [
		13150,
		[
			58255,
			13150
		]
	],
	"./components/edit/Percentage.vue": [
		76232,
		[
			58255,
			76232
		]
	],
	"./components/edit/Selection.vue": [
		54941,
		[
			54941
		]
	],
	"./components/edit/String.vue": [
		81055,
		[
			58255,
			81055
		]
	],
	"./components/edit/ValueToggle.vue": [
		69314,
		[
			58255,
			69314
		]
	],
	"./components/fields/Account.vue": [
		40998,
		[
			40998
		]
	],
	"./components/fields/Accountants.vue": [
		89447,
		[
			89447
		]
	],
	"./components/fields/ActivityTitle.vue": [
		29022,
		[
			29022
		]
	],
	"./components/fields/AdditionalUsers.vue": [
		79090,
		[
			79090
		]
	],
	"./components/fields/Address.vue": [
		97784,
		[
			97784
		]
	],
	"./components/fields/AddressEndOn.vue": [
		10511,
		[
			58255,
			10511
		]
	],
	"./components/fields/AddressSearch.vue": [
		67952,
		[
			67952
		]
	],
	"./components/fields/AddressStartOn.vue": [
		74298,
		[
			58255,
			74298
		]
	],
	"./components/fields/Addresses.vue": [
		68604,
		[
			68604
		]
	],
	"./components/fields/Adviser.vue": [
		29294,
		[
			29294
		]
	],
	"./components/fields/AdviserAccounts.vue": [
		14582,
		[
			14582
		]
	],
	"./components/fields/AdviserClientsQuickFilter.vue": [
		82321,
		[
			82321
		]
	],
	"./components/fields/AlertType.vue": [
		93037,
		[
			93037
		]
	],
	"./components/fields/BankAccount.vue": [
		70344,
		[
			70344
		]
	],
	"./components/fields/BankAccountNumber.vue": [
		94734,
		[
			94734
		]
	],
	"./components/fields/BankAccounts.vue": [
		10161,
		[
			10161
		]
	],
	"./components/fields/BaseField.vue": [
		64331,
		[]
	],
	"./components/fields/Boolean.vue": [
		88965,
		[
			88965
		]
	],
	"./components/fields/Broker.vue": [
		4800,
		[
			4800
		]
	],
	"./components/fields/ChipSize.vue": [
		52086,
		[
			52086
		]
	],
	"./components/fields/ChipType.vue": [
		82310,
		[
			82310
		]
	],
	"./components/fields/CompaniesHouseSearch.vue": [
		32433,
		[
			58255,
			32433
		]
	],
	"./components/fields/Company.vue": [
		77545,
		[
			77545
		]
	],
	"./components/fields/Country.vue": [
		33335,
		[
			58255,
			33335
		]
	],
	"./components/fields/Currency.vue": [
		31335,
		[
			31335
		]
	],
	"./components/fields/Custodian.vue": [
		47654,
		[
			47654
		]
	],
	"./components/fields/CustodyAccounts.vue": [
		48092,
		[
			48092
		]
	],
	"./components/fields/Date.vue": [
		53622,
		[
			53622
		]
	],
	"./components/fields/DatePicker.vue": [
		33369,
		[
			58255,
			33369
		]
	],
	"./components/fields/Datetime.vue": [
		80447,
		[
			80447
		]
	],
	"./components/fields/Day.vue": [
		62250,
		[
			62250
		]
	],
	"./components/fields/Days.vue": [
		88971,
		[
			88971
		]
	],
	"./components/fields/Declaration.vue": [
		85252,
		[
			85252
		]
	],
	"./components/fields/DeclarationConsent.vue": [
		20022,
		[
			20022
		]
	],
	"./components/fields/DerivativeExerciseType.vue": [
		89358,
		[
			89358
		]
	],
	"./components/fields/DerivativeSettlementType.vue": [
		62037,
		[
			62037
		]
	],
	"./components/fields/Description.vue": [
		234,
		[
			234
		]
	],
	"./components/fields/DescriptionModal.vue": [
		98083,
		[
			98083
		]
	],
	"./components/fields/DispositionResult.vue": [
		84012,
		[
			84012
		]
	],
	"./components/fields/DividendType.vue": [
		89034,
		[
			89034
		]
	],
	"./components/fields/Dob.vue": [
		47887,
		[
			58255,
			47887
		]
	],
	"./components/fields/Domiciled.vue": [
		2477,
		[
			2477
		]
	],
	"./components/fields/DynamicValue.vue": [
		19508,
		[
			19508
		]
	],
	"./components/fields/Email.vue": [
		5174,
		[
			5174
		]
	],
	"./components/fields/Enum.vue": [
		73708,
		[
			73708
		]
	],
	"./components/fields/EstateContacts.vue": [
		18971,
		[
			18971
		]
	],
	"./components/fields/Exchange.vue": [
		95905,
		[]
	],
	"./components/fields/FcaNumber.vue": [
		48369,
		[
			48369
		]
	],
	"./components/fields/FeeElement.vue": [
		46129,
		[
			46129
		]
	],
	"./components/fields/FeeElements.vue": [
		33257,
		[
			33257
		]
	],
	"./components/fields/FeePlan.vue": [
		43410,
		[
			43410
		]
	],
	"./components/fields/Fund.vue": [
		94059,
		[
			94059
		]
	],
	"./components/fields/FundManager.vue": [
		84172,
		[
			84172
		]
	],
	"./components/fields/FundStatus.vue": [
		58088,
		[
			58088
		]
	],
	"./components/fields/FundType.vue": [
		40947,
		[
			40947
		]
	],
	"./components/fields/HasAdviser.vue": [
		1938,
		[
			1938
		]
	],
	"./components/fields/Holding.vue": [
		73892,
		[
			73892
		]
	],
	"./components/fields/Icon.vue": [
		50812,
		[
			58159,
			50812
		]
	],
	"./components/fields/IhtType.vue": [
		75870,
		[
			75870
		]
	],
	"./components/fields/InputType.vue": [
		94111,
		[
			94111
		]
	],
	"./components/fields/Introducer.vue": [
		10858,
		[
			10858
		]
	],
	"./components/fields/Investor.vue": [
		94665,
		[
			94665
		]
	],
	"./components/fields/InvestorCategory.vue": [
		45823,
		[
			45823
		]
	],
	"./components/fields/InvestorCategoryGroup.vue": [
		87416,
		[
			87416
		]
	],
	"./components/fields/InvestorType.vue": [
		48580,
		[
			58255,
			48580
		]
	],
	"./components/fields/IsAdvised.vue": [
		54296,
		[
			58255,
			54296
		]
	],
	"./components/fields/Lookup.vue": [
		50783,
		[
			50783
		]
	],
	"./components/fields/MarketCapSource.vue": [
		34299,
		[
			34299
		]
	],
	"./components/fields/MediaAdviserType.vue": [
		40630,
		[
			40630
		]
	],
	"./components/fields/MediaFormat.vue": [
		88237,
		[
			88237
		]
	],
	"./components/fields/MediaInvestor.vue": [
		45659,
		[
			45659
		]
	],
	"./components/fields/MediaInvestorType.vue": [
		19081,
		[
			19081
		]
	],
	"./components/fields/MediaMarketingType.vue": [
		31918,
		[
			31918
		]
	],
	"./components/fields/Money.vue": [
		37893,
		[
			37893
		]
	],
	"./components/fields/Month.vue": [
		39301,
		[
			39301
		]
	],
	"./components/fields/Nationality.vue": [
		25665,
		[
			25665
		]
	],
	"./components/fields/NiNumber.vue": [
		25203,
		[
			25203
		]
	],
	"./components/fields/Nominee.vue": [
		88284,
		[
			43522
		]
	],
	"./components/fields/Number.vue": [
		99373,
		[
			99373
		]
	],
	"./components/fields/Offer.vue": [
		48276,
		[
			48276
		]
	],
	"./components/fields/OfferSignatories.vue": [
		13380,
		[
			13380
		]
	],
	"./components/fields/OfferStatus.vue": [
		3235,
		[
			3235
		]
	],
	"./components/fields/OfferType.vue": [
		434,
		[
			434
		]
	],
	"./components/fields/Options.vue": [
		15629,
		[
			15629
		]
	],
	"./components/fields/Organisation.vue": [
		20963,
		[
			20963
		]
	],
	"./components/fields/OrganisationStatus.vue": [
		58947,
		[
			58947
		]
	],
	"./components/fields/OrganisationType.vue": [
		86871,
		[
			86871
		]
	],
	"./components/fields/Percentage.vue": [
		39373,
		[
			39373
		]
	],
	"./components/fields/PhoneNumber.vue": [
		85834,
		[
			85834
		]
	],
	"./components/fields/PhoneNumbers.vue": [
		10186,
		[
			87805
		]
	],
	"./components/fields/PopupWysiwyg.vue": [
		1945,
		[
			1945
		]
	],
	"./components/fields/PowerOfAttorney.vue": [
		75107,
		[
			75107
		]
	],
	"./components/fields/PreviousCompanyNames.vue": [
		38814,
		[
			58255,
			38814
		]
	],
	"./components/fields/Product.vue": [
		64989,
		[
			64989
		]
	],
	"./components/fields/ProductOffers.vue": [
		3691,
		[
			58255,
			3691
		]
	],
	"./components/fields/ProductStatus.vue": [
		6091,
		[
			6091
		]
	],
	"./components/fields/ProductType.vue": [
		35709,
		[
			35709
		]
	],
	"./components/fields/Proposal.vue": [
		2684,
		[
			2684
		]
	],
	"./components/fields/Provider.vue": [
		46953,
		[
			46953
		]
	],
	"./components/fields/PublicAdviser.vue": [
		82833,
		[
			5214
		]
	],
	"./components/fields/ReceivingAgent.vue": [
		68426,
		[
			68426
		]
	],
	"./components/fields/Registrar.vue": [
		71667,
		[
			71667
		]
	],
	"./components/fields/RelationshipFilters.vue": [
		75541,
		[
			75541
		]
	],
	"./components/fields/RelationshipItem.vue": [
		80057,
		[
			80057
		]
	],
	"./components/fields/RelationshipSelectModal.vue": [
		65888,
		[
			65888
		]
	],
	"./components/fields/Relationships.vue": [
		61859,
		[
			61859
		]
	],
	"./components/fields/Repeater.vue": [
		25077,
		[
			25077
		]
	],
	"./components/fields/RestrictedPanel.vue": [
		33497,
		[
			33497
		]
	],
	"./components/fields/RestrictedPanelLookup.vue": [
		77699,
		[
			77699
		]
	],
	"./components/fields/Search.vue": [
		20942,
		[]
	],
	"./components/fields/Shortlist.vue": [
		72067,
		[
			72067
		]
	],
	"./components/fields/SortCode.vue": [
		70198,
		[
			70198
		]
	],
	"./components/fields/String.vue": [
		82149,
		[
			82149
		]
	],
	"./components/fields/TaxReferenceNumber.vue": [
		55548,
		[
			55548
		]
	],
	"./components/fields/TaxReferenceNumbers.vue": [
		73437,
		[
			73437
		]
	],
	"./components/fields/TaxResidency.vue": [
		89377,
		[
			89377
		]
	],
	"./components/fields/TaxStatus.vue": [
		91807,
		[
			91807
		]
	],
	"./components/fields/TaxYear.vue": [
		649,
		[
			649
		]
	],
	"./components/fields/TiptapConfigState.vue": [
		20223,
		[
			20223
		]
	],
	"./components/fields/Toggle.vue": [
		21037,
		[
			21037
		]
	],
	"./components/fields/Tranche.vue": [
		93099,
		[
			93099
		]
	],
	"./components/fields/Transaction.vue": [
		6481,
		[
			6481
		]
	],
	"./components/fields/Url.vue": [
		74539,
		[
			74539
		]
	],
	"./components/fields/User.vue": [
		40327,
		[]
	],
	"./components/fields/UserRoles.vue": [
		81977,
		[
			81977
		]
	],
	"./components/fields/UserStatus.vue": [
		47338,
		[
			47338
		]
	],
	"./components/fields/UserTaxCertificateDestination.vue": [
		8208,
		[
			8208
		]
	],
	"./components/fields/Validator.vue": [
		47908,
		[
			58255,
			47908
		]
	],
	"./components/fields/VctDividendReinvestment.vue": [
		68376,
		[
			68376
		]
	],
	"./components/fields/VctFundStatus.vue": [
		10630,
		[
			10630
		]
	],
	"./components/fields/VisibilityGroup.vue": [
		20184,
		[
			20184
		]
	],
	"./components/fields/Year.vue": [
		37929,
		[
			37929
		]
	],
	"./components/fields/groups/CompanyInfo.vue": [
		99405,
		[
			99405
		]
	],
	"./components/fields/groups/Organisation.vue": [
		94482,
		[
			94482
		]
	],
	"./components/fields/groups/VctStats.vue": [
		41359,
		[
			41359
		]
	],
	"./components/forms/CreateAccount.vue": [
		10271,
		[
			10271
		]
	],
	"./components/forms/CreateActivity.vue": [
		12124,
		[
			12124
		]
	],
	"./components/forms/CreateAdviser.vue": [
		16312,
		[
			16312
		]
	],
	"./components/forms/CreateClient.vue": [
		68610,
		[
			68610
		]
	],
	"./components/forms/CreateCompaniesNews.vue": [
		51265,
		[
			51265
		]
	],
	"./components/forms/CreateCompany.vue": [
		10753,
		[
			10753
		]
	],
	"./components/forms/CreateCustodian.vue": [
		56120,
		[
			56120
		]
	],
	"./components/forms/CreateFeePlan.vue": [
		51634,
		[
			51634
		]
	],
	"./components/forms/CreateFund.vue": [
		90600,
		[
			90600
		]
	],
	"./components/forms/CreateFundManager.vue": [
		54595,
		[
			54595
		]
	],
	"./components/forms/CreateFundsNews.vue": [
		14304,
		[
			14304
		]
	],
	"./components/forms/CreateHolding.vue": [
		48830,
		[
			48830
		]
	],
	"./components/forms/CreateInvestor.vue": [
		14898,
		[
			14898
		]
	],
	"./components/forms/CreateNominee.vue": [
		23381,
		[
			23381
		]
	],
	"./components/forms/CreateOffer.vue": [
		57842,
		[
			58255,
			57842
		]
	],
	"./components/forms/CreateProduct.vue": [
		83986,
		[
			58255,
			83986
		]
	],
	"./components/forms/CreateProposal.vue": [
		45019,
		[
			45019
		]
	],
	"./components/forms/CreateProvider.vue": [
		13175,
		[
			13175
		]
	],
	"./components/forms/CreateReceivingAgent.vue": [
		26361,
		[
			26361
		]
	],
	"./components/forms/CreateRegistrar.vue": [
		54182,
		[
			54182
		]
	],
	"./components/forms/CreateRegistration.vue": [
		2305,
		[
			2305
		]
	],
	"./components/forms/CreateShortlist.vue": [
		36397,
		[
			36397
		]
	],
	"./components/forms/CreateTranche.vue": [
		88122,
		[
			88122
		]
	],
	"./components/forms/CreateTransaction.vue": [
		91602,
		[
			91602
		]
	],
	"./components/forms/CreateUser.vue": [
		60126,
		[
			60126
		]
	],
	"./components/forms/Form.vue": [
		99267,
		[
			58255,
			99267
		]
	],
	"./components/forms/FormHistoryMenu.vue": [
		29405,
		[
			58255,
			29405
		]
	],
	"./components/forms/IntermediaryFeesFields.vue": [
		70068,
		[
			70068
		]
	],
	"./components/layouts/LayoutArticle.vue": [
		17446,
		[
			17446
		]
	],
	"./components/layouts/LayoutBulkImport.vue": [
		82167,
		[
			58255,
			82167
		]
	],
	"./components/layouts/LayoutDashboard.vue": [
		66180,
		[
			58255,
			66180
		]
	],
	"./components/layouts/LayoutDashboard2.vue": [
		59813,
		[
			58255,
			59813
		]
	],
	"./components/layouts/LayoutHeader.vue": [
		45274,
		[
			58255,
			45274
		]
	],
	"./components/layouts/LayoutOffer.vue": [
		7847,
		[
			58255,
			7847
		]
	],
	"./components/layouts/LayoutOfferSkeleton.vue": [
		82060,
		[
			58255,
			82060
		]
	],
	"./components/layouts/LayoutProfile.vue": [
		17094,
		[
			58255,
			17094
		]
	],
	"./components/layouts/LayoutProfileSkeleton.vue": [
		899,
		[
			58255,
			56137
		]
	],
	"./components/layouts/parts/KanbanBoard.vue": [
		44624,
		[
			44624
		]
	],
	"./components/layouts/parts/KanbanColumn.vue": [
		77408,
		[
			77408
		]
	],
	"./components/modals/InvestorAdviserSelector.vue": [
		26784,
		[
			26784
		]
	],
	"./components/questionnaire/Appropriateness.vue": [
		15226,
		[
			15226
		]
	],
	"./components/sidebars/LibrarySidebar.vue": [
		63346,
		[]
	],
	"./components/sidebars/ReportsSidebar.vue": [
		16212,
		[
			16212
		]
	],
	"./components/sidebars/Sidebar.vue": [
		15178,
		[]
	],
	"./components/sidebars/SystemBulkImportSidebar.vue": [
		80505,
		[
			80505
		]
	],
	"./components/sidebars/SystemDataEntrySidebar.vue": [
		87074,
		[
			87074
		]
	],
	"./components/sidebars/TransactionsSidebar.vue": [
		67843,
		[]
	],
	"./components/skeleton/Bone.vue": [
		42779,
		[
			42779
		]
	],
	"./components/skeleton/Skeleton.vue": [
		93051,
		[
			93051
		]
	],
	"./components/skeleton/Squiggle.vue": [
		4637,
		[
			4637
		]
	],
	"./components/skeleton/TableSimple.vue": [
		16382,
		[
			58255,
			16382
		]
	],
	"./components/table/AppTable.vue": [
		66198,
		[
			58255,
			66198
		]
	],
	"./components/table/AppTableNested.vue": [
		99492,
		[
			58255,
			99492
		]
	],
	"./components/table/AppTablePanel.vue": [
		1639,
		[
			1639
		]
	],
	"./components/table/AppTableSimple.vue": [
		49764,
		[
			58255,
			49764
		]
	],
	"./components/table/ColumnVisibilityButton.vue": [
		61487,
		[
			58255,
			61487
		]
	],
	"./components/table/DefaultValue.vue": [
		70331,
		[
			70331
		]
	],
	"./components/table/DisplayButton.vue": [
		87211,
		[
			87211
		]
	],
	"./components/table/FilterButton.vue": [
		78575,
		[
			58255,
			78575
		]
	],
	"./components/table/Footer.vue": [
		35234,
		[
			58255,
			35234
		]
	],
	"./components/table/Header.vue": [
		24904,
		[
			58255,
			2523
		]
	],
	"./components/table/HeaderDataTableSelect.vue": [
		10887,
		[
			58255,
			10887
		]
	],
	"./components/table/ItemDataTableSelect.vue": [
		35225,
		[
			58255,
			35225
		]
	],
	"./components/table/ItemSlot.vue": [
		61756,
		[
			58255,
			61756
		]
	],
	"./components/table/Loading.vue": [
		4498,
		[
			4498
		]
	],
	"./components/table/NoData.vue": [
		80135,
		[
			80135
		]
	],
	"./components/table/Top.vue": [
		98627,
		[
			98627
		]
	],
	"./components/widgets/AppWidget.vue": [
		53038,
		[
			53038
		]
	],
	"./components/widgets/AppWidgetChart.vue": [
		17968,
		[
			17968
		]
	],
	"./components/widgets/AppWidgetGroup.vue": [
		56863,
		[
			56863
		]
	],
	"./components/widgets/AppWidgetPerformance.vue": [
		27133,
		[
			27133
		]
	],
	"./components/widgets/AppWidgetResultList.vue": [
		42397,
		[
			58255,
			42397
		]
	],
	"./components/widgets/AppWidgetSparkline.vue": [
		15331,
		[
			58255,
			15331
		]
	],
	"./components/widgets/AppWidgetTable.vue": [
		25234,
		[
			25234
		]
	],
	"./components/widgets/AppWidgetTimeline.vue": [
		20502,
		[
			20502
		]
	],
	"./components/widgets/AppWidgetTwitter.vue": [
		57622,
		[
			70504,
			57622
		]
	],
	"./components/widgets/AppWidgetValue.vue": [
		92078,
		[
			92078
		]
	],
	"./packages/additional-needs/components/AdditionalNeedStatus.vue": [
		11462,
		[
			11462
		]
	],
	"./packages/investors/components/InvestorApplicationButton.vue": [
		76821,
		[
			76821
		]
	],
	"./packages/investors/components/InvestorApplicationProgressAlert.vue": [
		46901,
		[
			58255,
			46901
		]
	],
	"./packages/investors/components/InvestorApplicationProgressCircular.vue": [
		26833,
		[
			26833
		]
	],
	"./packages/investors/components/InvestorApplicationProgressText.vue": [
		9322,
		[
			9322
		]
	],
	"./packages/investors/components/InvestorApplicationProgressTimeline.vue": [
		25846,
		[
			25846
		]
	],
	"./packages/investors/components/InvestorCustodianBalanceModal.vue": [
		93982,
		[
			93982
		]
	],
	"./packages/investors/components/InvestorCustodyAccountsTable.vue": [
		97200,
		[
			58255,
			97200
		]
	],
	"./packages/investors/components/InvestorDetailsConfirmationModal.vue": [
		98820,
		[
			98820
		]
	],
	"./packages/investors/components/InvestorIntermediariesTable.vue": [
		3278,
		[
			3278
		]
	],
	"./packages/investors/components/InvestorIntermediaryModal.vue": [
		77644,
		[
			58255,
			77644
		]
	],
	"./packages/investors/components/WithdrawInvestorCashButton.vue": [
		25196,
		[
			25196
		]
	],
	"./packages/investors/views/Dashboard.vue": [
		92434,
		[
			58255,
			92434
		]
	],
	"./packages/investors/views/PortfolioRestrictedNotice.vue": [
		6913,
		[
			6913
		]
	],
	"./plugins/tiptap/components/TiptapAlert.vue": [
		54525,
		[]
	],
	"./plugins/tiptap/components/TiptapAlertOptions.vue": [
		22323,
		[
			22323
		]
	],
	"./plugins/tiptap/components/TiptapCheckbox.vue": [
		51954,
		[]
	],
	"./plugins/tiptap/components/TiptapCheckboxOptions.vue": [
		21334,
		[
			21334
		]
	],
	"./plugins/tiptap/components/TiptapChip.vue": [
		68800,
		[]
	],
	"./plugins/tiptap/components/TiptapChipOptions.vue": [
		12050,
		[
			12050
		]
	],
	"./plugins/tiptap/components/TiptapConfig.vue": [
		90826,
		[]
	],
	"./plugins/tiptap/components/TiptapConfigOptions.vue": [
		25287,
		[
			25287
		]
	],
	"./plugins/tiptap/components/TiptapDynamicValue.vue": [
		59997,
		[]
	],
	"./plugins/tiptap/components/TiptapDynamicValueOptions.vue": [
		77314,
		[
			77314
		]
	],
	"./plugins/tiptap/components/TiptapExpansionPanel.vue": [
		58746,
		[]
	],
	"./plugins/tiptap/components/TiptapExpansionPanelOptions.vue": [
		31973,
		[
			31973
		]
	],
	"./plugins/tiptap/components/TiptapInput.vue": [
		32083,
		[]
	],
	"./plugins/tiptap/components/TiptapInputOptions.vue": [
		19631,
		[
			19631
		]
	],
	"./plugins/tiptap/components/TiptapOptionsMenu.vue": [
		46218,
		[
			58255,
			46218
		]
	],
	"./plugins/tiptap/components/TiptapRadioItem.vue": [
		19870,
		[]
	],
	"./plugins/tiptap/components/TiptapRadioList.vue": [
		66767,
		[]
	],
	"./views/Accounts.vue": [
		77184,
		[
			58255,
			77184
		]
	],
	"./views/Adviser.vue": [
		96935,
		[
			96935
		]
	],
	"./views/AdviserDashboard.vue": [
		5635,
		[
			58255,
			5635
		]
	],
	"./views/AdviserInvestorPortfolioRestrictedNotice.vue": [
		31507,
		[
			31507
		]
	],
	"./views/AgreementModal.vue": [
		40400,
		[
			40400
		]
	],
	"./views/BulkShareAllotment.vue": [
		90669,
		[
			90669
		]
	],
	"./views/BulkShareAllotmentModal.vue": [
		60259,
		[
			58255,
			60259
		]
	],
	"./views/ChangeInvestorCategoryButton.vue": [
		67445,
		[
			67445
		]
	],
	"./views/ChangeInvestorEmailModal.vue": [
		98544,
		[
			98544
		]
	],
	"./views/CreateClientButton.vue": [
		52501,
		[
			58255,
			52501
		]
	],
	"./views/CreateCustodyAccountButton.vue": [
		14748,
		[
			14748
		]
	],
	"./views/CreateIntermediaryButton.vue": [
		53317,
		[
			53317
		]
	],
	"./views/CreateOrganisationButton.vue": [
		55667,
		[
			58255,
			55667
		]
	],
	"./views/Dashboard.vue": [
		87239,
		[
			87239
		]
	],
	"./views/Debug.vue": [
		48734,
		[
			58255,
			48734
		]
	],
	"./views/DownloadCovi.vue": [
		89072,
		[
			70504,
			54294,
			89072
		]
	],
	"./views/DownloadLastCategorisationResults.vue": [
		76265,
		[
			70504,
			54294,
			76265
		]
	],
	"./views/DownloadOfferApplicationForm.vue": [
		99895,
		[
			99895
		]
	],
	"./views/DownloadPlatformAgreement.vue": [
		19207,
		[
			19207
		]
	],
	"./views/DownloadProposalApplicationForm.vue": [
		92274,
		[
			92274
		]
	],
	"./views/DownloadTermsConditions.vue": [
		42844,
		[
			42844
		]
	],
	"./views/DriManagement.vue": [
		43768,
		[
			58255,
			43768
		]
	],
	"./views/HoldingActionModal.vue": [
		82137,
		[
			82137
		]
	],
	"./views/HoldingCreateButton.vue": [
		90035,
		[
			90035
		]
	],
	"./views/Index.vue": [
		76345,
		[
			76345
		]
	],
	"./views/IntermediaryCards.vue": [
		58671,
		[
			58671
		]
	],
	"./views/IntermediaryDetails.vue": [
		40123,
		[
			58255,
			40123
		]
	],
	"./views/Investments.vue": [
		2549,
		[
			2549
		]
	],
	"./views/InvestorOnboarding.vue": [
		1561,
		[
			58255,
			1561
		]
	],
	"./views/InvestorOnboardingAddress.vue": [
		95486,
		[
			58255,
			95486
		]
	],
	"./views/InvestorOnboardingAdviser.vue": [
		65045,
		[
			58255,
			65045
		]
	],
	"./views/InvestorOnboardingCategory.vue": [
		61719,
		[
			58255,
			61719
		]
	],
	"./views/InvestorOnboardingClassification.vue": [
		36488,
		[
			58255,
			36488
		]
	],
	"./views/InvestorOnboardingDeclaration.vue": [
		33981,
		[
			58255,
			33981
		]
	],
	"./views/InvestorOnboardingTerms.vue": [
		34808,
		[
			58255,
			34808
		]
	],
	"./views/InvestorRegistrationBoard.vue": [
		5260,
		[
			5260
		]
	],
	"./views/InvestorRegistrationModal.vue": [
		1686,
		[
			1686
		]
	],
	"./views/InvestorRegistrationProgress.vue": [
		95621,
		[
			95621
		]
	],
	"./views/InvestorRegistrationStatus.vue": [
		59065,
		[
			59065
		]
	],
	"./views/InvestorRegistrations.vue": [
		98141,
		[
			58255,
			70504,
			54294,
			98141
		]
	],
	"./views/Library.vue": [
		78491,
		[
			78491
		]
	],
	"./views/LibraryIndex.vue": [
		9353,
		[
			9353
		]
	],
	"./views/LibraryMediaModal.vue": [
		20543,
		[
			58255,
			20543
		]
	],
	"./views/NewsManagementModal.vue": [
		77991,
		[
			58255,
			77991
		]
	],
	"./views/OfferAddToShortlistButton.vue": [
		22234,
		[
			22234
		]
	],
	"./views/OfferInvestNowButton.vue": [
		67586,
		[
			67586
		]
	],
	"./views/Offers.vue": [
		24910,
		[
			58255,
			24910
		]
	],
	"./views/OffersAll.vue": [
		41278,
		[
			41278
		]
	],
	"./views/OffersEisSeis.vue": [
		85980,
		[
			85980
		]
	],
	"./views/OffersEsg.vue": [
		36972,
		[
			36972
		]
	],
	"./views/OffersIht.vue": [
		49654,
		[
			49654
		]
	],
	"./views/OffersPmi.vue": [
		29088,
		[
			29088
		]
	],
	"./views/OffersSingleCompany.vue": [
		35825,
		[
			35825
		]
	],
	"./views/OffersTable.vue": [
		94207,
		[
			94207
		]
	],
	"./views/OffersVct.vue": [
		1672,
		[
			1672
		]
	],
	"./views/OrganisationStatusIndicator.vue": [
		19103,
		[
			19103
		]
	],
	"./views/Portfolio.vue": [
		48904,
		[
			48904
		]
	],
	"./views/PortfolioClientRegistrations.vue": [
		99360,
		[
			99360
		]
	],
	"./views/PortfolioClients.vue": [
		56373,
		[
			58255,
			56373
		]
	],
	"./views/PortfolioDashboard.vue": [
		92139,
		[
			58255,
			92139
		]
	],
	"./views/PortfolioDetail.vue": [
		37734,
		[
			58255,
			37734
		]
	],
	"./views/PortfolioDetailEisSeis.vue": [
		88787,
		[
			58255,
			70504,
			54294,
			88787
		]
	],
	"./views/PortfolioDetailEsg.vue": [
		68701,
		[
			58255,
			70504,
			54294,
			68701
		]
	],
	"./views/PortfolioDetailIht.vue": [
		91270,
		[
			58255,
			70504,
			54294,
			91270
		]
	],
	"./views/PortfolioDetailPmiClosed.next.vue": [
		70801,
		[
			58255,
			70504,
			54294,
			70801
		]
	],
	"./views/PortfolioDetailPmiClosed.vue": [
		4366,
		[
			58255,
			70504,
			54294,
			4366
		]
	],
	"./views/PortfolioDetailPmiOpen.vue": [
		8783,
		[
			58255,
			70504,
			54294,
			8783
		]
	],
	"./views/PortfolioDetailSingleCompany.vue": [
		96071,
		[
			58255,
			70504,
			54294,
			96071
		]
	],
	"./views/PortfolioDetailSummary.vue": [
		26424,
		[
			58255,
			70504,
			54294,
			26424
		]
	],
	"./views/PortfolioDetailVct.vue": [
		21190,
		[
			58255,
			70504,
			54294,
			21190
		]
	],
	"./views/ProductActionModal.vue": [
		41639,
		[
			64020
		]
	],
	"./views/ProposalActions.vue": [
		7527,
		[
			7527
		]
	],
	"./views/ProposalFinancials.vue": [
		63713,
		[
			63713
		]
	],
	"./views/ProposalFundingStatus.vue": [
		40821,
		[
			40821
		]
	],
	"./views/ProposalInvestmentsModal.vue": [
		97152,
		[
			58255,
			97152
		]
	],
	"./views/ProposalProgress.vue": [
		50629,
		[
			50629
		]
	],
	"./views/Proposals.vue": [
		24768,
		[
			58255,
			70504,
			54294,
			24768
		]
	],
	"./views/ProposalsBoard.vue": [
		54123,
		[
			54123
		]
	],
	"./views/ProposalsModal.vue": [
		80901,
		[
			58255,
			80901
		]
	],
	"./views/ProviderInvestorActions.vue": [
		92181,
		[
			92181
		]
	],
	"./views/ProviderInvestorLoaModal.vue": [
		73975,
		[
			73975
		]
	],
	"./views/RemoteApplicationActionModal.vue": [
		86237,
		[
			8618
		]
	],
	"./views/RemoteApplicationBlocks.vue": [
		28687,
		[
			58255,
			28687
		]
	],
	"./views/RemoteApplicationBuilder.vue": [
		11348,
		[
			58255,
			11348
		]
	],
	"./views/RemoteApplicationBuilderModal.vue": [
		80587,
		[
			80587
		]
	],
	"./views/RemoteApplicationStatus.vue": [
		10080,
		[
			10080
		]
	],
	"./views/Reports.vue": [
		99613,
		[]
	],
	"./views/ReportsAdviserDocumentsActivity.vue": [
		93390,
		[
			58255,
			70504,
			54294,
			93390
		]
	],
	"./views/ReportsAdviserMarketingActivity.vue": [
		72546,
		[
			58255,
			70504,
			54294,
			72546
		]
	],
	"./views/ReportsAdviserSecurityActivity.vue": [
		46064,
		[
			58255,
			70504,
			54294,
			46064
		]
	],
	"./views/ReportsAuthActivity.vue": [
		75982,
		[
			58255,
			75982
		]
	],
	"./views/ReportsCashFees.vue": [
		65949,
		[
			58255,
			70504,
			54294,
			65949
		]
	],
	"./views/ReportsClientPortfolio.vue": [
		32890,
		[
			58255,
			70504,
			54294,
			32890
		]
	],
	"./views/ReportsClientPortfolioEisSeis.vue": [
		21154,
		[
			58255,
			70504,
			54294,
			98773
		]
	],
	"./views/ReportsClientPortfolioIht.vue": [
		75235,
		[
			58255,
			70504,
			54294,
			75235
		]
	],
	"./views/ReportsClientPortfolioPmi.vue": [
		59837,
		[
			58255,
			70504,
			54294,
			59837
		]
	],
	"./views/ReportsClientPortfolioPmiClosed.vue": [
		41133,
		[
			58255,
			70504,
			54294,
			63514
		]
	],
	"./views/ReportsClientPortfolioPmiOpen.vue": [
		30573,
		[
			58255,
			70504,
			54294,
			52954
		]
	],
	"./views/ReportsClientPortfolioSingleCompany.vue": [
		18088,
		[
			58255,
			70504,
			54294,
			95707
		]
	],
	"./views/ReportsClientPortfolioSummary.vue": [
		56946,
		[
			70504,
			54294,
			56946
		]
	],
	"./views/ReportsClientPortfolioSummaryByTaxStatus.vue": [
		40577,
		[
			70504,
			54294,
			62958
		]
	],
	"./views/ReportsClientPortfolioSummaryPmi.vue": [
		1507,
		[
			70504,
			54294,
			23888
		]
	],
	"./views/ReportsClientPortfolioTransactions.vue": [
		70871,
		[
			70504,
			54294,
			70871
		]
	],
	"./views/ReportsClientPortfolioVct.vue": [
		3683,
		[
			58255,
			70504,
			54294,
			26064
		]
	],
	"./views/ReportsClientSummary.vue": [
		11686,
		[
			58255,
			11686
		]
	],
	"./views/ReportsClientsCustodialAccounts.vue": [
		24112,
		[
			58255,
			24112
		]
	],
	"./views/ReportsDisposalsFailures.vue": [
		69386,
		[
			58255,
			70504,
			54294,
			69386
		]
	],
	"./views/ReportsDisposalsSales.vue": [
		48669,
		[
			58255,
			70504,
			54294,
			48669
		]
	],
	"./views/ReportsDividendTransactions.vue": [
		22938,
		[
			58255,
			22938
		]
	],
	"./views/ReportsHoldings.vue": [
		77418,
		[
			58255,
			77418
		]
	],
	"./views/ReportsIntegrationHoldings.vue": [
		97039,
		[
			58255,
			70504,
			54294,
			97039
		]
	],
	"./views/ReportsIntegrationTranches.vue": [
		40218,
		[
			58255,
			70504,
			54294,
			40218
		]
	],
	"./views/ReportsInvestmentsEisSeis.vue": [
		38965,
		[
			58255,
			70504,
			54294,
			38965
		]
	],
	"./views/ReportsInvestmentsIht.vue": [
		11599,
		[
			58255,
			70504,
			54294,
			11599
		]
	],
	"./views/ReportsInvestmentsPmi.vue": [
		68785,
		[
			58255,
			70504,
			54294,
			68785
		]
	],
	"./views/ReportsInvestmentsSingleCompany.next.vue": [
		33934,
		[
			58255,
			70504,
			54294,
			33934
		]
	],
	"./views/ReportsInvestmentsSingleCompany.vue": [
		88131,
		[
			58255,
			70504,
			54294,
			88131
		]
	],
	"./views/ReportsInvestmentsVct.vue": [
		90706,
		[
			58255,
			70504,
			54294,
			90706
		]
	],
	"./views/ReportsInvestorDocumentsActivity.vue": [
		38142,
		[
			58255,
			70504,
			54294,
			38142
		]
	],
	"./views/ReportsInvestorFlowActivity.vue": [
		5117,
		[
			58255,
			70504,
			54294,
			5117
		]
	],
	"./views/ReportsInvestorMarketingActivity.vue": [
		81780,
		[
			58255,
			70504,
			54294,
			81780
		]
	],
	"./views/ReportsInvestorSecurityActivity.vue": [
		99060,
		[
			58255,
			70504,
			54294,
			99060
		]
	],
	"./views/ReportsNegligibleValue.vue": [
		23980,
		[
			58255,
			70504,
			54294,
			23980
		]
	],
	"./views/ReportsNotifications.vue": [
		56984,
		[
			58255,
			70504,
			54294,
			56984
		]
	],
	"./views/ReportsPendingApplications.vue": [
		91813,
		[
			58255,
			91813
		]
	],
	"./views/ReportsPmiTranches.vue": [
		10977,
		[
			58255,
			10977
		]
	],
	"./views/ReportsPositionReconciliation.vue": [
		18718,
		[
			58255,
			18718
		]
	],
	"./views/ReportsProposals.vue": [
		727,
		[
			58255,
			727
		]
	],
	"./views/ReportsRegistrations.vue": [
		17434,
		[
			58255,
			17434
		]
	],
	"./views/ReportsTaxReturn.vue": [
		705,
		[
			58255,
			705
		]
	],
	"./views/ReportsTaxYear.vue": [
		49894,
		[
			58255,
			70504,
			54294,
			49894
		]
	],
	"./views/ReportsTranches.vue": [
		19578,
		[
			58255,
			19578
		]
	],
	"./views/ReportsTransactionReconciliation.vue": [
		73400,
		[
			58255,
			73400
		]
	],
	"./views/ReportsTransactionsCashDeposits.vue": [
		14889,
		[
			58255,
			70504,
			54294,
			14889
		]
	],
	"./views/ReportsTransactionsCashWithdrawals.vue": [
		70947,
		[
			58255,
			70504,
			54294,
			70947
		]
	],
	"./views/ReportsTransactionsFee.vue": [
		65135,
		[
			58255,
			70504,
			54294,
			65135
		]
	],
	"./views/ReportsTransactionsIncome.vue": [
		79727,
		[
			58255,
			70504,
			54294,
			79727
		]
	],
	"./views/ReportsVctMaturity.vue": [
		6731,
		[
			58255,
			70504,
			54294,
			6731
		]
	],
	"./views/RiskSummary.vue": [
		22341,
		[
			70504,
			54294,
			22341
		]
	],
	"./views/Settings.vue": [
		54979,
		[
			54979
		]
	],
	"./views/SettingsAdditionalNeeds.vue": [
		64182,
		[
			58255,
			64182
		]
	],
	"./views/SettingsAgreements.vue": [
		5223,
		[
			58255,
			5223
		]
	],
	"./views/SettingsAppropriateness.vue": [
		90474,
		[
			58255,
			90474
		]
	],
	"./views/SettingsBilling.vue": [
		70141,
		[
			58255,
			70141
		]
	],
	"./views/SettingsBranding.vue": [
		32975,
		[
			58255,
			32975
		]
	],
	"./views/SettingsBrandingPreview.vue": [
		56019,
		[
			66272,
			56019
		]
	],
	"./views/SettingsCommunication.vue": [
		60975,
		[
			58255,
			60975
		]
	],
	"./views/SettingsCorporateProfile.vue": [
		54405,
		[
			58255,
			54405
		]
	],
	"./views/SettingsFinancial.vue": [
		91397,
		[
			58255,
			91397
		]
	],
	"./views/SettingsFirmInformation.vue": [
		53202,
		[
			58255,
			53202
		]
	],
	"./views/SettingsIntegrations.vue": [
		33133,
		[
			58255,
			33133
		]
	],
	"./views/SettingsIntermediary.vue": [
		62735,
		[
			58255,
			62735
		]
	],
	"./views/SettingsIntroduction.vue": [
		65864,
		[
			58255,
			65864
		]
	],
	"./views/SettingsInvestorBankAccount.vue": [
		97409,
		[
			58255,
			97409
		]
	],
	"./views/SettingsInvestors.vue": [
		26260,
		[
			58255,
			26260
		]
	],
	"./views/SettingsLettersOfAuthority.vue": [
		78253,
		[
			58255,
			78253
		]
	],
	"./views/SettingsNetworkSetup.vue": [
		38543,
		[
			58255,
			38543
		]
	],
	"./views/SettingsProfile.vue": [
		60371,
		[
			58255,
			60371
		]
	],
	"./views/SettingsProviders.vue": [
		6996,
		[
			58255,
			6996
		]
	],
	"./views/SettingsUsers.vue": [
		11766,
		[
			58255,
			11766
		]
	],
	"./views/SettingsVisibilityGroups.vue": [
		97353,
		[
			58255,
			97353
		]
	],
	"./views/Shortlist.vue": [
		59934,
		[
			58255,
			59934
		]
	],
	"./views/ShortlistFeeIllustrationModal.vue": [
		64872,
		[
			58255,
			64872
		]
	],
	"./views/ShortlistProposalModal.vue": [
		1747,
		[
			58255,
			1747
		]
	],
	"./views/Shortlists.vue": [
		51859,
		[
			58255,
			51859
		]
	],
	"./views/SystemAdviserManagement.vue": [
		47189,
		[
			58255,
			47189
		]
	],
	"./views/SystemBulkImport.vue": [
		78603,
		[
			78603
		]
	],
	"./views/SystemBulkImportAdvisers.vue": [
		15090,
		[
			15090
		]
	],
	"./views/SystemBulkImportDocuments.vue": [
		14945,
		[
			14945
		]
	],
	"./views/SystemBulkImportFunds.vue": [
		79638,
		[
			79638
		]
	],
	"./views/SystemBulkImportInvestmentTransactions.vue": [
		24419,
		[
			24419
		]
	],
	"./views/SystemBulkImportInvestors.vue": [
		29794,
		[
			29794
		]
	],
	"./views/SystemBulkImportMorningstar.vue": [
		97057,
		[
			58255,
			97057
		]
	],
	"./views/SystemBulkImportRelatedOrganisations.vue": [
		66772,
		[
			66772
		]
	],
	"./views/SystemBulkImportValuations.vue": [
		25840,
		[
			25840
		]
	],
	"./views/SystemBulkImportVct.vue": [
		34181,
		[
			34181
		]
	],
	"./views/SystemBulkUpdate.vue": [
		44420,
		[
			44420
		]
	],
	"./views/SystemBulkUpdateOffers.vue": [
		3979,
		[
			3979
		]
	],
	"./views/SystemChartDebugger.vue": [
		34687,
		[
			58255,
			34687
		]
	],
	"./views/SystemDataEntry.vue": [
		65024,
		[
			65024
		]
	],
	"./views/SystemDataEntryAccounts.vue": [
		69688,
		[
			69688
		]
	],
	"./views/SystemDataEntryAccountsCreate.vue": [
		3816,
		[
			58255,
			3816
		]
	],
	"./views/SystemDataEntryAccountsEdit.vue": [
		48575,
		[
			58255,
			48575
		]
	],
	"./views/SystemDataEntryActivity.vue": [
		22826,
		[
			22826
		]
	],
	"./views/SystemDataEntryActivityCreate.vue": [
		45951,
		[
			58255,
			45951
		]
	],
	"./views/SystemDataEntryActivityEdit.vue": [
		65912,
		[
			58255,
			65912
		]
	],
	"./views/SystemDataEntryAdvisers.vue": [
		39712,
		[
			39712
		]
	],
	"./views/SystemDataEntryAdvisersCreate.vue": [
		29775,
		[
			58255,
			29775
		]
	],
	"./views/SystemDataEntryAdvisersEdit.vue": [
		70055,
		[
			58255,
			70055
		]
	],
	"./views/SystemDataEntryAgreements.vue": [
		55995,
		[
			55995
		]
	],
	"./views/SystemDataEntryCompanies.vue": [
		65659,
		[
			65659
		]
	],
	"./views/SystemDataEntryCompaniesCreate.vue": [
		99811,
		[
			58255,
			99811
		]
	],
	"./views/SystemDataEntryCompaniesEdit.vue": [
		75980,
		[
			58255,
			75980
		]
	],
	"./views/SystemDataEntryCustodians.vue": [
		31497,
		[
			31497
		]
	],
	"./views/SystemDataEntryCustodiansCreate.vue": [
		90764,
		[
			58255,
			90764
		]
	],
	"./views/SystemDataEntryCustodiansEdit.vue": [
		38642,
		[
			58255,
			38642
		]
	],
	"./views/SystemDataEntryFeePlans.vue": [
		76643,
		[
			76643
		]
	],
	"./views/SystemDataEntryFeePlansCreate.vue": [
		23709,
		[
			58255,
			23709
		]
	],
	"./views/SystemDataEntryFeePlansEdit.vue": [
		34801,
		[
			58255,
			34801
		]
	],
	"./views/SystemDataEntryFundManagers.vue": [
		41094,
		[
			41094
		]
	],
	"./views/SystemDataEntryFundManagersCreate.vue": [
		84993,
		[
			58255,
			84993
		]
	],
	"./views/SystemDataEntryFundManagersEdit.vue": [
		82398,
		[
			58255,
			82398
		]
	],
	"./views/SystemDataEntryFunds.vue": [
		51618,
		[
			51618
		]
	],
	"./views/SystemDataEntryFundsCreate.vue": [
		62518,
		[
			58255,
			62518
		]
	],
	"./views/SystemDataEntryFundsEdit.vue": [
		32673,
		[
			58255,
			32673
		]
	],
	"./views/SystemDataEntryHoldings.vue": [
		59503,
		[
			59503
		]
	],
	"./views/SystemDataEntryHoldingsEdit.vue": [
		62298,
		[
			58255,
			62298
		]
	],
	"./views/SystemDataEntryInvestors.vue": [
		85364,
		[
			85364
		]
	],
	"./views/SystemDataEntryInvestorsCreate.vue": [
		94042,
		[
			58255,
			94042
		]
	],
	"./views/SystemDataEntryInvestorsEdit.vue": [
		83886,
		[
			58255,
			83886
		]
	],
	"./views/SystemDataEntryLettersOfAuthority.vue": [
		81919,
		[
			58255,
			81919
		]
	],
	"./views/SystemDataEntryNominees.vue": [
		2457,
		[
			2457
		]
	],
	"./views/SystemDataEntryNomineesCreate.vue": [
		20696,
		[
			58255,
			20696
		]
	],
	"./views/SystemDataEntryNomineesEdit.vue": [
		80038,
		[
			58255,
			57657
		]
	],
	"./views/SystemDataEntryOffers.vue": [
		78583,
		[
			78583
		]
	],
	"./views/SystemDataEntryOffersCreate.vue": [
		20976,
		[
			58255,
			20976
		]
	],
	"./views/SystemDataEntryOffersEdit.vue": [
		18396,
		[
			58255,
			18396
		]
	],
	"./views/SystemDataEntryProducts.vue": [
		66157,
		[
			66157
		]
	],
	"./views/SystemDataEntryProductsCreate.vue": [
		51046,
		[
			58255,
			51046
		]
	],
	"./views/SystemDataEntryProductsEdit.vue": [
		27579,
		[
			58255,
			27579
		]
	],
	"./views/SystemDataEntryProviders.vue": [
		83431,
		[
			83431
		]
	],
	"./views/SystemDataEntryProvidersCreate.vue": [
		83623,
		[
			58255,
			83623
		]
	],
	"./views/SystemDataEntryProvidersEdit.vue": [
		63256,
		[
			58255,
			63256
		]
	],
	"./views/SystemDataEntryReceivingAgents.vue": [
		75681,
		[
			75681
		]
	],
	"./views/SystemDataEntryReceivingAgentsCreate.vue": [
		29644,
		[
			58255,
			29644
		]
	],
	"./views/SystemDataEntryReceivingAgentsEdit.vue": [
		40599,
		[
			58255,
			40599
		]
	],
	"./views/SystemDataEntryRegistrars.vue": [
		90909,
		[
			90909
		]
	],
	"./views/SystemDataEntryRegistrarsCreate.vue": [
		33103,
		[
			58255,
			33103
		]
	],
	"./views/SystemDataEntryRegistrarsEdit.vue": [
		654,
		[
			58255,
			654
		]
	],
	"./views/SystemDataEntryRegistrations.vue": [
		69960,
		[
			69960
		]
	],
	"./views/SystemDataEntryRegistrationsEdit.vue": [
		50408,
		[
			58255,
			50408
		]
	],
	"./views/SystemDataEntryRemoteApplications.vue": [
		47019,
		[
			47019
		]
	],
	"./views/SystemDataEntryTerms.vue": [
		45640,
		[
			45640
		]
	],
	"./views/SystemDataEntryTranches.vue": [
		57836,
		[
			57836
		]
	],
	"./views/SystemDataEntryTranchesCreate.vue": [
		46593,
		[
			58255,
			46593
		]
	],
	"./views/SystemDataEntryTranchesEdit.vue": [
		7346,
		[
			58255,
			7346
		]
	],
	"./views/SystemDataEntryTransactions.vue": [
		82948,
		[
			82948
		]
	],
	"./views/SystemDataEntryTransactionsCreate.vue": [
		31993,
		[
			58255,
			31993
		]
	],
	"./views/SystemDataEntryTransactionsEdit.vue": [
		11825,
		[
			58255,
			11825
		]
	],
	"./views/SystemDataEntryUsers.vue": [
		86416,
		[
			58255,
			86416
		]
	],
	"./views/SystemDataEntryUsersCreate.vue": [
		31253,
		[
			58255,
			31253
		]
	],
	"./views/SystemDataEntryUsersEdit.vue": [
		49341,
		[
			58255,
			49341
		]
	],
	"./views/SystemDebug.vue": [
		17990,
		[
			58255,
			17990
		]
	],
	"./views/SystemDynamicFormBuilder.vue": [
		94319,
		[
			94319
		]
	],
	"./views/SystemDynamicFormDebugger.vue": [
		23561,
		[
			58255,
			23561
		]
	],
	"./views/SystemErrorDebugger.vue": [
		50440,
		[
			58255,
			58159,
			50440
		]
	],
	"./views/SystemEvents.vue": [
		5023,
		[
			58255,
			5023
		]
	],
	"./views/SystemIcons.vue": [
		37166,
		[
			58255,
			37166
		]
	],
	"./views/SystemPdfDebugger.vue": [
		30376,
		[
			58255,
			70504,
			54294,
			30376
		]
	],
	"./views/SystemProposalCalculationDebugger.vue": [
		33928,
		[
			58255,
			33928
		]
	],
	"./views/SystemWysiwygDebugger.vue": [
		73672,
		[
			58255,
			70504,
			54294,
			73672
		]
	],
	"./views/TermsActionModal.vue": [
		22666,
		[
			58255,
			285
		]
	],
	"./views/TrancheActionModal.vue": [
		5247,
		[
			27628
		]
	],
	"./views/TransactionActionModal.vue": [
		64594,
		[
			58255,
			64594
		]
	],
	"./views/Transactions.vue": [
		35393,
		[
			35393
		]
	],
	"./views/User.vue": [
		17739,
		[
			17739
		]
	],
	"./views/UserModal.vue": [
		11414,
		[
			58255,
			11414
		]
	],
	"./views/VisibilityGroupModal.vue": [
		31244,
		[
			58255,
			31244,
			3719
		]
	],
	"./views/error/FatalError.vue": [
		47661,
		[
			58255,
			47661
		]
	],
	"./views/error/PageError.vue": [
		91537,
		[
			91537
		]
	],
	"./views/offer/Index.vue": [
		57961,
		[
			57961
		]
	],
	"./views/offer/Template.vue": [
		76993,
		[
			10623
		]
	],
	"./views/offer/base/KeyDocuments.vue": [
		42103,
		[
			58255,
			42103
		]
	],
	"./views/offer/base/Overview.vue": [
		22023,
		[
			22023
		]
	],
	"./views/offer/base/OverviewTable.vue": [
		66661,
		[
			66661
		]
	],
	"./views/offer/base/ProductDistribution.vue": [
		77317,
		[
			77317
		]
	],
	"./views/offer/base/RequestInfo.vue": [
		36524,
		[
			36524
		]
	],
	"./views/offer/base/TabCompanyDetails.vue": [
		38388,
		[
			38388
		]
	],
	"./views/offer/base/TabCompanyOverview.vue": [
		74345,
		[
			74345
		]
	],
	"./views/offer/base/TabDownloads.vue": [
		96744,
		[
			96744
		]
	],
	"./views/offer/base/TabFees.vue": [
		56689,
		[
			56689
		]
	],
	"./views/offer/base/TabFundOverview.vue": [
		44170,
		[
			44170
		]
	],
	"./views/offer/base/TabKeyInformation.vue": [
		96672,
		[
			58255,
			96672
		]
	],
	"./views/offer/base/TabManagementOverview.vue": [
		54924,
		[
			54924
		]
	],
	"./views/offer/base/TabManagerOverview.vue": [
		25925,
		[
			25925
		]
	],
	"./views/offer/base/TabNews.vue": [
		2266,
		[
			58255,
			2266
		]
	],
	"./views/offer/base/TabProductOverview.vue": [
		52973,
		[
			58255,
			52973
		]
	],
	"./views/offer/base/Tabs.vue": [
		60673,
		[
			58255,
			60673
		]
	],
	"./views/offer/base/Timeline.vue": [
		31908,
		[
			31908
		]
	],
	"./views/offer/base/Videos.vue": [
		52061,
		[
			58255,
			58159,
			52061
		]
	],
	"./views/offer/template/Alt/OverviewTable.vue": [
		80338,
		[
			80338
		]
	],
	"./views/offer/template/Alt/TabKeyInformation.vue": [
		30695,
		[
			30695
		]
	],
	"./views/offer/template/Alt/Tabs.vue": [
		14917,
		[
			58255,
			14917
		]
	],
	"./views/offer/template/Eis/OverviewTable.vue": [
		7823,
		[
			7823
		]
	],
	"./views/offer/template/Eis/TabKeyInformation.vue": [
		40145,
		[
			40145
		]
	],
	"./views/offer/template/Eis/Tabs.vue": [
		73357,
		[
			58255,
			73357
		]
	],
	"./views/offer/template/Iht/OverviewTable.vue": [
		35866,
		[
			35866
		]
	],
	"./views/offer/template/Iht/TabKeyInformation.vue": [
		73103,
		[
			73103
		]
	],
	"./views/offer/template/Iht/Tabs.vue": [
		74129,
		[
			58255,
			74129
		]
	],
	"./views/offer/template/Nq/OverviewTable.vue": [
		20124,
		[
			20124
		]
	],
	"./views/offer/template/Nq/TabKeyInformation.vue": [
		83799,
		[
			83799
		]
	],
	"./views/offer/template/Nq/Tabs.vue": [
		7585,
		[
			58255,
			7585
		]
	],
	"./views/offer/template/Pmi/OverviewTable.vue": [
		96143,
		[
			96143
		]
	],
	"./views/offer/template/Pmi/TabKeyInformation.vue": [
		54216,
		[
			54216
		]
	],
	"./views/offer/template/Pmi/Tabs.vue": [
		43018,
		[
			58255,
			43018
		]
	],
	"./views/offer/template/Vct/OverviewTable.vue": [
		391,
		[
			391
		]
	],
	"./views/offer/template/Vct/TabKeyInformation.vue": [
		61316,
		[
			61316
		]
	],
	"./views/offer/template/Vct/Tabs.vue": [
		79891,
		[
			58255,
			79891
		]
	]
};
function webpackAsyncContext(req) {
	try {
		if(!__webpack_require__.o(map, req)) {
			return Promise.resolve().then(function() {
	var e = new Error("Cannot find module '" + req + "'");
	e.code = 'MODULE_NOT_FOUND';
	throw e;
});
		}
	} catch(err) {
		return Promise.reject(err);
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids[1].map(__webpack_require__.e)).then(function() { return __webpack_require__(id); });
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 11234;
module.exports = webpackAsyncContext;